<template>
  <div>
    <div class="pa-5 pt-0 pb-0">
      <v-row style="justify-content:between">
        <v-col cols="12" sm="12" md="6" lg="6" class="sub-title">Reporting</v-col>
        <v-col class="pt-2" cols="12" sm="12" md="2" lg="2">
          <v-text-field
          class="mt-0"
          style="max-width:300px"
          v-model="selectedFilter.search"
          append-icon="search"
          label="Search"
          single-line
          hide-details>
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="12" md="2" lg="2" v-if="isSuperAdmin || isAM">
          <v-autocomplete
            :items="AM"
            item-value="id"
            item-text="name"
            label="AM"
            v-model="selectedFilter.AM"
            hide-details
            outlined
            dense
            @change="searchFilter"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="12" md="2" lg="2" v-if="isSuperAdmin || isCC">
          <v-autocomplete
            :items="CC"
            item-value="id"
            item-text="name"
            label="CC"
            v-model="selectedFilter.CC"
            hide-details
            outlined
            dense
            @change="searchFilter"
          ></v-autocomplete>
        </v-col>
      </v-row>
    </div>
    <div class="pa-5 pt-2">
      <v-data-table
        class="drafts-data-table elevation-1"
        :loading="loading"
        :headers="headers"
        :items="filteredItems"
        :search="selectedFilter.search"
        :items-per-page="5"
      >
        <template v-slot:[`item.name`]="{ item }">
          <td :class="`text-left ${item.overdue ? 'overdue-highlight' : ''}`">
            <a @click="openCampaignModal(item.campaignID)" class="custom-link">{{item.name || ''}}</a>
          </td>
        </template>
        <template v-slot:[`item.reviewMeetingDate`]="{ item }">
          <td :class="`text-center ${item.overdue ? 'overdue-highlight' : ''}`">
            <a
              class="custom-link"
              :href="`/campaigns/timeline?campaignID=${item.campaignID}`"
              :target="'_blank'"
              v-if="isLinkAllow"
            >
              {{item.reviewMeetingDate || ''}}
            </a>
            <span v-else>{{item.reviewMeetingDate || ''}}</span>
          </td>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <td :class="`text-center ${item.overdue ? 'overdue-highlight' : ''}`">
            <a
            class="custom-link"
            :href="'/campaign-report-internal?id='+item.campaignID"
            target="_blank">
              {{item.submittedInfs || 0}} / {{item.pairingInfs || 0}}
            </a>
          </td>
        </template>
        <template v-slot:[`item.submissionDate`]="{ item }">
          <td :class="`text-center ${item.overdue ? 'overdue-highlight' : ''}`">
            <span>{{item.submissionDate ? formatDate(item.submissionDate) : ''}}</span>
          </td>
        </template>
        <template v-slot:[`item.reviewDeck`]="{ item }">
          <td :class="`text-center ${item.overdue ? 'overdue-highlight' : ''}`" style="min-width:100px">
            <v-btn
              class="btn-view-review-deck"
              v-if="item.reviewDeckURL"
              :href="item.reviewDeckURL"
              target="_blank"
              color="warning"
              v-bind="attrs"
              v-on="on"
              small
              text
            >
              <v-icon class="mr-0" x-small left>remove_red_eye</v-icon>
              <span>View Review Deck</span>
            </v-btn>
            <v-btn
              class="btn-view-review-deck"
              v-else
              color="warning"
              v-bind="attrs"
              v-on="on"
              @click="openReviewDeckDialog(item)"
              small
            >
              Add Review Deck
            </v-btn>
          </td>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <td :class="`text-center ${item.overdue ? 'overdue-highlight' : ''}`" style="min-width:100px">
            <v-btn
              data-toggle="tooltip"
              data-placement="top"
              title="Close Campaign"
              @click="proceedApproveCampaign(item.campaignID)"
              color="success"
              class="ims-action"
            >
              <v-icon color="white" small>power_settings_new</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
    </div>
    <!-- Review Deck URL Modal Dialog -->
    <review-deck-url-modal
    v-model="reviewDeckURLDialog"
    :value="reviewDeckURLDialog"
    :item="reviewDeckItem"
    :dateCol="reviewDeckCol"
    @saveClicked="saveReviewDeckURL"
    />
  </div>
</template>
<script>
import config from '@/config';
import campaignConfig from '../Campaign/config'
import campaignAPIs from '../Campaign/campaignAPIs'
import ReviewDeckUrlModal from '../Campaign/ReviewMeeting/ReviewDeckUrlModal';
import { mapState } from 'vuex'
import moment from 'moment';
export default {
  name: 'DraftsDataTable',
  components: {
    ReviewDeckUrlModal
  },
  data() {
    return {
      headers: [
        {
          text: 'Deal Name',
          value: 'name',
          align: 'center'
        },
        {
          text: 'Review date',
          value: 'reviewMeetingDate',
          align: 'center'
        },
        {
          text: 'Stats submitted',
          value: 'status',
          align: 'center'
        },
        {
          text: 'Deadline for submission',
          value: 'submissionDate',
          align: 'center'
        },
        {
          text: 'Review Deck',
          value: 'reviewDeck',
          align: 'center'
        },
        {
          text: 'Action',
          value: 'action',
          align: 'center'
        }
      ],
      items: [],
      filteredItems: [],
      dashboardStatusDisplay: campaignConfig.dashboardStatusDisplay,
      selectedFilter: {
        AM: '',
        CC: ''
      },
      loading: false,
      reviewDeckURLDialog: false,
      reviewDeckItem: {},
      reviewDeckCol: 'reviewDeck'
    }
  },
  props: ['AM', 'CC'],
  computed: {
    ...mapState({
      dashboardCampaigns: state => state.campaign.dashboardReportings,
      savedDashboardStatus: state => state.campaign.savedDashboardStatus
    }),
    isSuperAdmin: function() {
      return Number(this.$store.state.user.role) === config.userRoles.SUPER_ADMIN_HIGH
    },
    isAM: function() {
      return Number(this.$store.state.user.role) === config.userRoles.ACCOUNT_MANAGER
    },
    isCC: function() {
      return Number(this.$store.state.user.role) === config.userRoles.AD_STRATEGIST
    },
    currentUserRole: function () {
      return Number(this.$store.state.user.role)
    },
    currentUserID: function () {
      return this.$store.state.user.id
    },
    isLinkAllow: function() {
      return Number(this.$store.state.user.role) === config.userRoles.SUPER_ADMIN_HIGH ||
      Number(this.$store.state.user.role) === config.userRoles.SUPER_ADMIN_LOW ||
      Number(this.$store.state.user.role) === config.userRoles.ACCOUNT_MANAGER
    }
  },
  async mounted() {
    this.init()
    setTimeout(() => {
      this.setAMCC()
    }, 2000)
  },
  methods: {
    async init() {
      this.loading = true
      await this.$store.dispatch('campaign/getDashboardReporting', {})
      this.items = this.dashboardCampaigns.map(d => d)
      this.filteredItems = this.items.map(item => item)
      this.loading = false
    },
    changeStatus(item) {
      // change checkbox status
      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to confirm date?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          await this.$store.dispatch('campaign/saveDashboardStatus', {
            id: item.id,
            type: config.dashboardTypes.brief,
            status: 1
          })
          this.init()
        } else {
          item.checkedStatus = 0
        }
      })
    },
    formatDate(date) {
      if (!date || date.includes('/')) return '';
      return moment(date).format('DD/MM/YYYY');
    },
    getDashboardStatusDisplay(status) {
      if (!status) return ''
      return this.dashboardStatusDisplay[status]
    },
    searchFilter() {
      this.filteredItems = this.items.map(i => i)
      if (this.selectedFilter.AM) {
        this.filteredItems = this.filteredItems.filter(item => (item.users && item.users.includes(this.selectedFilter.AM)))
      }
      if (this.selectedFilter.CC) {
        this.filteredItems = this.filteredItems.filter(item => (item.users && item.users.includes(this.selectedFilter.CC)))
      }
    },
    openCampaignModal(campaignID) {
      this.$emit('viewCampaign', campaignID)
    },
    proceedApproveCampaign(campaignID) {
      var campaignConfirmation = campaignConfig.campaignConfirmation.approval[config.campaignStatus.ONGOING];
      var sweetAlertOptions = {
        title: campaignConfirmation['confirmation']['title'],
        text: campaignConfirmation['confirmation']['text'],
        type: campaignConfirmation['confirmation']['type'],
        showCancelButton: true,
        confirmButtonText: campaignConfirmation['confirmation']['confirmText'],
        cancelButtonText: campaignConfirmation['confirmation']['cancelText'],
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: login => {
          return campaignAPIs
          .approveCampaign(campaignID, config.campaignStatus.ONGOING)
          .then(response => {
            return response;
          })
          .catch(error => {
            // Request failed.
            console.log('error', error);
            // Show error message
            this.$swal.showValidationError('Something went wrong! Please try again or contact our admin');
          });
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }
      // Display confirmation box
      this.$swal(sweetAlertOptions).then(result => {
        if (result.value) {
          // Show success message
          this.$swal({
            title: 'Success',
            text: 'Successfully Closed Campaign',
            type: 'success'
          });
          this.init()
        } else {
          // Do nothing for now
        }
      });
    },
    saveReviewDeckURL(item) {
      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to save?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          await this.$store.dispatch('campaignTimeline/saveReviewDeck', {
            dashboardID: item.id,
            campaignID: item.campaignID,
            reviewDeckURL: item.reviewDeck.reviewDateURL
          })
          this.init()
        }
      })
    },
    openReviewDeckDialog(item) {
      item.reviewDeck = {
        reviewDateURL: ''
      }
      this.reviewDeckItem = Object.assign({}, item)
      this.reviewDeckURLDialog = true
    },
    setAMCC() {
      if (this.currentUserRole === config.userRoles.ACCOUNT_MANAGER) {
        let matchAM = this.AM.find(a => a.id === this.currentUserID)
        this.selectedFilter.AM = matchAM
      }
      if (this.currentUserRole === config.userRoles.AD_STRATEGIST) {
        this.selectedFilter.CC = this.currentUserID
      }
    }
  }
}
</script>
<style scoped>
  .filter-area {
    justify-content: right;
  }
</style>



// WEBPACK FOOTER //
// ReportingDataTable.vue?2d407148